<template>
<div class="w-full md:w-1/2 p-8 bg-white rounded flex flex-col">
    <div class="flex-1">
        <h3 class="text-xl font-bold text-center">
            <slot name="name"></slot>
        </h3>
        <div class="my-4 text-center">
            <div class="flex items-start justify-center -ml-2">
                <span class="text-sm text-gray-darker leading-loose">$</span>
                <span class="text-primary text-6xl font-bold leading-none">
                    <slot name="price"></slot>
                </span>
            </div>
            <p class="text-sm" v-if="$slots.additionalPrice">+ $<slot name="additionalPrice"></slot> per additional inbox</p>
            <p class="text-sm" v-if="$slots.description"><slot name="description"></slot></p>
            <p></p>
            <slot name="frequency"></slot>
        </div>

        <ul class="text-sm">
            <li class="flex items-center my-4" v-for="feature in features" :key="feature.value">
                <div v-if="feature.type === 'included'" class="bg-primary-lighter text-primary rounded-full h-5 w-5 text-xs flex items-center justify-center mr-2">
                    <font-awesome-icon :icon="['fas', 'check']"></font-awesome-icon>
                </div>
                <div v-else-if="feature.type === 'excluded'" class="bg-destructive-lighter text-destructive rounded-full h-5 w-5 text-xs flex items-center justify-center mr-2">
                    <font-awesome-icon :icon="['fas', 'times']"></font-awesome-icon>
                </div>
                <div v-else-if="feature.type === 'bonus'" class="bg-accent text-white rounded-full h-5 w-5 text-xs flex items-center justify-center mr-2">
                    <font-awesome-icon :icon="['fas', 'star']"></font-awesome-icon>
                </div>
                {{ feature.value }}
            </li>
        </ul>
    </div>
    <slot name="action"></slot>
</div>
</template>

<script>
export default {
    props: {
        features: {
            type: Array,
            required: true,
        },
    },
}
</script>
